import { NavLink } from "react-router-dom";
import { NAV_ITEMS } from "./TabBar";

/**
 * Desktop-only navigatierail (>= lg). Onder de lg-grens bestaat dit
 * element niet (hidden) en houdt de mobiele TabBar-pill het over -
 * het mobiele beeld verandert dus met geen pixel.
 */
export function SideNav() {
  return (
    <aside className="hidden lg:flex fixed inset-y-0 left-0 z-40 w-60 flex-col border-r border-card-border bg-card px-3 pt-7 pb-5">
      <div className="flex items-center gap-3 px-2.5 pb-7">
        <img
          src="/favicon.png"
          alt=""
          width={34}
          height={34}
          className="select-none"
          draggable={false}
        />
        <span className="text-[16px] font-bold tracking-tight leading-tight">
          Mijn SlimStroom
        </span>
      </div>
      <nav className="flex flex-col gap-1">
        {NAV_ITEMS.map(({ to, label, Icon }) => (
          <NavLink
            key={to}
            to={to}
            end
            className={({ isActive }) =>
              `pressable flex items-center gap-3 rounded-xl px-3.5 py-2.5 text-sm font-semibold transition-colors ${
                isActive
                  ? "bg-accent-soft text-accent"
                  : "text-ink-mute hover:text-ink hover:bg-card-soft"
              }`
            }
          >
            <Icon />
            {label}
          </NavLink>
        ))}
      </nav>
      <a
        href="https://help.mijnslimstroom.nl"
        target="_blank"
        rel="noreferrer"
        className="mt-auto px-3.5 py-2 text-xs text-ink-mute hover:text-ink"
      >
        Hulp nodig? help.mijnslimstroom.nl
      </a>
    </aside>
  );
}
